import { render, staticRenderFns } from "./commentsItem.vue?vue&type=template&id=76651adc&scoped=true"
import script from "./commentsItem.vue?vue&type=script&lang=js"
export * from "./commentsItem.vue?vue&type=script&lang=js"
import style0 from "./commentsItem.vue?vue&type=style&index=0&id=76651adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76651adc",
  null
  
)

export default component.exports